import { AttributeTreeData } from '@/models/reports/attribute-tree-data';
import { ConditionOperator } from './condition-operator';
import { SelectItem } from './select-item';
import { LogicalOperator } from './logical-operator';
// @ts-ignore
import * as uuid from 'uuid';

export class Filter {
    public logicalOperator: string;
    public field: AttributeTreeData | null;
    public operator: string | null;
    public value: string | null;
    public variableName: string | null;
    public foreignKeyValues: Array<SelectItem>;
    public isVariable: boolean;
    public showValue: boolean;
    public filterGroupId: string;
    public id: string = uuid.v4();

    public constructor(filterGroupId?: string) {
        if (filterGroupId != null) {
            this.filterGroupId = filterGroupId;
        }
        this.logicalOperator = 'And';
        this.field = null;
        this.operator = null;
        this.value = null;
        this.variableName = null;
        this.isVariable = false;
        this.foreignKeyValues = new Array<SelectItem>();
    }

    public clear() {
        this.logicalOperator = 'And';
        this.field = null;
        this.operator = null;
        this.value = null;
        this.variableName = null;
        this.isVariable = false;
        this.foreignKeyValues = new Array<SelectItem>();
    }
}
